<div class="bp-modal mod-lg">
	<ng-template *ngTemplateOutlet="templateRef"></ng-template>
</div>
